import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";

import { setState } from "actions";
import { setPage } from "actions/router";
import SvgIcon from "components/Common/SvgIcon";
import TestBotOpener from "components/Common/TestBotOpener";
import UserImage from "components/Common/UserImage";
import { User } from "resourceModels";
import { getResource } from "selectors/resources";

import "./style.scss";

const BLOCK_NAME = "Navigator";

export class Navigator extends React.Component {
  /**
   * @returns {Array}
   */
  getButtons() {
    const { root } = this.props;

    const buttons = [
      {
        id: "responses",
        icon: "Categories",
        label: "Answers",
        align: "left",
        route:
          root.getIn(["lastPageHistory", "answers"]) || "/answers"
      },
      {
        id: "inbox",
        icon: "Dialogue",
        label: "Questions",
        align: "left",
        route: (
          root.getIn(["lastPageHistory", "questions"]) ||
          "/questions"
        )
      },
      {
        id: "conversations",
        icon: "Chat",
        label: "Conversations",
        align: "left",
        route: (
          root.getIn(["lastPageHistory", "conversations"]) ||
          "/conversations"
        )
      },
      {
        id: "analytics",
        icon: "Chart",
        label: "Analytics",
        align: "left",
        route: (
          root.getIn(["lastPageHistory", "analytics"]) ||
          "/analytics"
        )
      },
      {
        id: "settings",
        icon: "Gear",
        label: "Settings",
        align: "left",
        route:
          root.getIn(["lastPageHistory", "settings"]) || "/settings"
      }
    ];

    return buttons;
  }

  /**
   * @param {String} icon
   * @returns {ReactElement|null}
   */
  static getIcon(icon) {
    if (!icon) {
      return null;
    }

    return (
      <SvgIcon
        icon={icon}
        customClassName={`${BLOCK_NAME}__button__icon`}
        fillColor="currentColor"
      />
    );
  }

  /**
   * @param {String} buttonRoute
   */
  isActive(buttonRoute) {
    const { location } = this.props;
    const currentRouteRoot = location.pathname.split("/")[1];
    const buttonRouteRoot = buttonRoute.split("/")[1];

    return currentRouteRoot === buttonRouteRoot;
  }

  /**
   * @returns {ReactElement}
   */
  render() {
    const {
      /** @type User */
      user,
      setReduxState
    } = this.props;

    return (
      <div className={`${BLOCK_NAME}`}>
        {this.getButtons().map(
          button => (
            <Link
              to={button.route}
              className={classNames(`${BLOCK_NAME}__button Button Button--glyph Button--text`, {
                [`${BLOCK_NAME}__button--active`]: this.isActive(button.route)
              })}
              key={button.route}
            >
              {Navigator.getIcon(button.icon)}
              {button.label}
            </Link>
          )
        )}
        <div className={`${BLOCK_NAME}__right-icons`}>
          <TestBotOpener
            customClassName={`${BLOCK_NAME}__test`}
            buttonProps={{
              text: "Test Bot",
              title: "Test your bot",
              clearWithBorder: true,
              fillColor: "currentColor",
              icon: "PlaySmall",
              size: "small"
            }}
          />
          <UserImage
            customClassName={`${BLOCK_NAME}__avatar`}
            user={user}
            height="32px"
            width="32px"
            onClick={() => setReduxState("MODAL", {
              isOpen: true,
              view: "MODAL_PROFILE",
              modalProps: {}
            })}
          />
        </div>
      </div>
    );
  }
}

Navigator.propTypes = {
  user: PropTypes.instanceOf(User).isRequired,
  setReduxState: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired,
  root: ImmutablePropTypes.map.isRequired
};

/**
 * @param {Object} state
 * @returns {Object}
 */
function mapState(state) {
  const {
    root, global
  } = state;

  return {
    user: getResource(state, "user"),
    root,
    global
  };
}

/**
 * @param {Function} dispatch
 * @returns {Object}
 */
function mapDispatch(dispatch) {
  return bindActionCreators({
    setPage,
    setReduxState: setState
  }, dispatch);
}

const Connector = withRouter(connect(mapState, mapDispatch)(Navigator));

export default Connector;
